import React, { useMemo } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedCommuniques } from '../../../services/communiqueService';
import { Communique } from '../../../types/communique';
import Table from '../../../components/common/Table';
import pageStyles from '../../Page.module.css';
import { FaEye } from 'react-icons/fa';
import Icon from '../../../components/common/Icon';


interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};

const CommuniquesListPage: React.FC = () => {
  const columns = useMemo<ColumnDef<Communique>[]>(() => [
    {
      header: 'رقم البلاغ',
      accessorKey: 'communique_number',
    },
    {
      header: 'تاريخ الاجتماع',
      accessorFn: (row) => new Date(row.meeting_date).toLocaleDateString('ar-EG'),
    },
    {
      header: 'تاريخ الإنشاء',
      accessorFn: (row) => new Date(row.created_at).toLocaleDateString('ar-EG'),
    },
    {
      id: 'actions',
      header: 'إجراءات',
      cell: ({ row }) => (
        <Link to={`/admin/communiques/${row.original.id}`} className={pageStyles.actionButton} title="عرض التفاصيل">
          <Icon as={FaEye} style={pageStyles.icon } />
        </Link>
      ),
    },
  ], []);

  const { table, isLoading, Pagination , searchTerm, setSearchTerm} = useServerSideTable<Communique>({
    columns,
    fetchData: getPagedCommuniques,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>قائمة البلاغات</h1>
      </div>
      <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <div className={pageStyles.pageContent}>
        <Table table={table} isLoading={isLoading} />
      </div>
      <Pagination />
    </div>
  );
};

export default CommuniquesListPage;
